import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
    campagneId?: ModelId,
}

const initialState: State = {

};

export const viewCampagneSlice = createSlice({
    name: 'viewCampagne',
    initialState,
    reducers: {
        update(state, action: PayloadAction<ModelId | undefined>) {
            state.campagneId = action.payload;
        },
    }
});
